import { REQUEST_URL } from "../constants";
import { PaginationQueryModel, FreightForwardingInputModel, EcommerceFulfillmentInputModel } from "../models";
import { RequestUtil } from "../utils";

export const QuotationService = {
  filterQuotation,
  getQuotationDetail,
  getQuotationHistory,
  createFreightForwarding,
  createEcommerceFulfillment,
  updateQuotationStatus,
  deleteQuotation
};

function filterQuotation(query: PaginationQueryModel & { searchValue?: string } & { filterValue?: string } = {}) {
  const url = REQUEST_URL.FILTER_QUOTATION;

  return RequestUtil.get({ url, query: query });
}

function getQuotationDetail(quotationCode: string) {
  const url = REQUEST_URL.GET_QUOTATION_DETAIL.replace("{QUOTATION_CODE}", quotationCode);;

  return RequestUtil.get({ url });
}

function getQuotationHistory(quotationId: string) {
  const url = REQUEST_URL.GET_QUOTATION_HISTORY.replace("{QUOTATION_ID}", quotationId);;

  return RequestUtil.get({ url });
}

function createFreightForwarding(data: FreightForwardingInputModel) {
  const url = REQUEST_URL.CREATE_FREIGHT_FORWARDING;

  return RequestUtil.post({ url, data });
}

function createEcommerceFulfillment(data: EcommerceFulfillmentInputModel) {
  const url = REQUEST_URL.CREATE_ECOMMERCE_FULFILLMENT;

  return RequestUtil.post({ url, data });
}

function updateQuotationStatus(quotationCode: string, data: { status: string }) {
  const url = REQUEST_URL.UPDATE_QUOTATION.replace("{QUOTATION_CODE}", quotationCode);

  return RequestUtil.put({ url, data });
}

function deleteQuotation(quotationCode: string) {
  const url = REQUEST_URL.DELETE_QUOTATION.replace("{QUOTATION_CODE}", quotationCode);

  return RequestUtil.delete({ url });
}